'use strict'

const showPortalPropContextMenu = function (event, data, fallbackHandler) {
  if (typeof window !== 'undefined' && typeof window.PORTAL_SHOW_PROP_CONTEXT_MENU === 'function') {
    window.PORTAL_SHOW_PROP_CONTEXT_MENU(event, data)
    return true
  }
  if (typeof fallbackHandler === 'function') {
    fallbackHandler(event, data)
    return true
  }
  if (!event) return false
  event.preventDefault()
  event.stopPropagation()
  return true
}

export {
  showPortalPropContextMenu
}
